import React from 'react';
import Sidebar from '../../Sidebar/Sidebar';
import Header from '../Header';

const NotificationsPage = () => {
  const notifications = [
    'Notification 1',
    'Notification 2',
    'Notification 3',
    'Notification 4',
    'Notification 5',
    'Notification 6',
    'Notification 7',
    'Notification 8',
  ];

  return (
    <div className="flex h-screen">
        <Sidebar/>
        <div className="flex-1 flex flex-col">
            <Header/>
            <div className="p-4">
                <h2 className="text-2xl font-bold mb-4">All Notifications</h2>
                <ul>
                    {notifications.map((notification, index) => (
                        <li key={index} className="mb-2">{notification}</li>
                    ))}
                </ul>
            </div>
        </div>
    </div>
  );
};

export default NotificationsPage;
